import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

/**
 * Guest links are emailed as ``/d/{token}`` (path). HashRouter only sees the
 * fragment, and email clients often strip ``#…`` entirely — so a path hit must
 * rewrite into ``/#/d/{token}`` before React mounts.
 */
function bridgeGuestPathToHash(): void {
  const match = window.location.pathname.match(/^\/d\/([^/]+)\/?$/)
  if (!match) return
  const token = match[1]
  const search = window.location.search
  window.location.replace(
    `${window.location.origin}/#/d/${token}${search}`,
  )
}

bridgeGuestPathToHash()

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
